export default __webpack_public_path__ + "static/media/chat.3280a62e.svg";